﻿import {Controller} from "./helpers/controller";

export class MarqueeControl extends Controller {
    

    private lerp = {current: 0, target: 0};
    private interpolationFactor = 0.4;
    private speed = 0.05;
    private direction = -1; // -1 (to-left), 1 (to-right) 
    
    constructor(element: HTMLElement) {
        super(element);

        for(var i = 0; i < element.children.length; i++)
        {
            element.append(element.children[i]);
        }
        // Init
        element.style.cssText = `position: relative; display: inline-flex; white-space: nowrap;`;
        var lastChild:HTMLElement = element.children[element.children.length-1] as HTMLElement;
        lastChild.style.cssText = `position: absolute; left: ${100 * -this.direction}%;`;
        
        this.render();
    }

    calcLerp = (current:number, target:number, factor:number) => {return current * (1 - factor) + target * factor};


    animate = () => {
        this.lerp.target += this.speed;
        this.lerp.current = this.calcLerp(this.lerp.current, this.lerp.target, this.interpolationFactor);

        if (this.lerp.target > 100) {
            this.lerp.current -= this.lerp.target;
            this.lerp.target = 0;
        }

        const x = this.lerp.current * this.direction;
        this._element.style.transform = `translateX(${x}%)`;
    }

    render = () => {
        this.animate();
        window.requestAnimationFrame(() => this.render());
    }
}